export const CRITICAL_REFETCH_INTERVAL_MS = 15_000;
export const OPERATIONAL_REFETCH_INTERVAL_MS = 30_000;
export const REPORT_REFETCH_INTERVAL_MS = 60_000;

function activePageFreshness(refetchInterval) {
    return Object.freeze({
        staleTime: 0,
        refetchInterval,
        refetchIntervalInBackground: false,
        refetchOnMount: "always",
        refetchOnWindowFocus: "always",
        refetchOnReconnect: "always"
    });
}

// Temperature readings, checks, and sensor readings can affect an immediate
// food-safety decision. WebSocket invalidation reduces latency when it arrives,
// but polling is the fleet-wide correctness mechanism because live-update hubs
// are process-local and native clients do not keep a background socket.
export const criticalFreshness = activePageFreshness(CRITICAL_REFETCH_INTERVAL_MS);

// Other operational records still need a bounded freshness window while their
// page is open, but do not require the tighter food-safety polling interval.
export const operationalFreshness = activePageFreshness(OPERATIONAL_REFETCH_INTERVAL_MS);

// Reports can issue several parallel aggregate requests, so use a lower polling
// rate while retaining the same mount, focus, reconnect, and resume guarantees.
export const reportFreshness = activePageFreshness(REPORT_REFETCH_INTERVAL_MS);
